
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kol/[modelId]/[modelName]",
      function () {
        return require("private-next-pages/kol/[modelId]/[modelName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kol/[modelId]/[modelName]"])
      });
    }
  